import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthContext';
import { patientAuthFlow } from './patientAuthFlow';

export default function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/patient/entry" replace />;
  }

  const state = patientAuthFlow.getState();

  if (state.approvalStatus === 'pending') {
    return <Navigate to="/patient/approval-pending" replace />;
  }
  if (state.approvalStatus === 'rejected' || state.approvalStatus === 'need_update') {
    return <Navigate to="/patient/verification-update-required" replace />;
  }
  if (state.approvalStatus !== 'approved' || !state.dashboardReady) {
    return <Navigate to="/patient/entry" replace />;
  }

  return <>{children}</>;
}
